import { Box, Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { TONE, TYPE } from '../../styles/theme';

// Inline error/empty state. `fullPage` centres it as a whole screen, for routes like
// collection detail that render no other chrome. The 404 doesn't use this — it's a real
// page built from PageLayout.
export default function ErrorCard({ eyebrow, heading, body, action, children, fullPage }) {
  const t = useColorModeValue(TONE.light, TONE.dark);
  const border = useColorModeValue("rgba(139,62,18,0.18)", "rgba(200,169,126,0.13)");

  const card = (
    <Box
      border="1px solid"
      borderColor={border}
      borderRadius="16px"
      bg={t.surface}
      px={{ base: 6, md: 10 }}
      py={10}
      textAlign="center"
      maxW="440px"
      w="100%"
    >
      {eyebrow && (
        <Text
          fontSize="12px"
          letterSpacing="0.2em"
          textTransform="uppercase"
          color={t.accent}
          mb={4}
        >
          {eyebrow}
        </Text>
      )}
      <Text
        as="h2"
        fontFamily="heading"
        fontSize={TYPE.blockTitle}
        fontWeight={400}
        color={t.text}
        lineHeight={1.3}
        mb={body || children ? 3 : 0}
      >
        {heading}
      </Text>
      {body && (
        <Text fontSize={TYPE.body} color={t.dim} lineHeight={1.75} mb={action || children ? 6 : 0}>
          {body}
        </Text>
      )}
      {children}
      {action && (
        <Flex gap={3} justify="center" mt={children ? 4 : 0}>
          {(Array.isArray(action) ? action : [action]).map((a, i) => (
            <Button key={i} size="sm" onClick={a.onClick} variant={i === 0 ? "solid" : "outline"}>
              {a.label}
            </Button>
          ))}
        </Flex>
      )}
    </Box>
  );

  if (!fullPage) return card;

  return (
    <Flex
      align="center" justify="center" bg={t.bg} px={6}
      sx={{ height: "100vh", "@supports (height: 100dvh)": { height: "100dvh" } }}
    >
      {card}
    </Flex>
  );
}
